import React from "react";
import { Link } from "react-router-dom";
import {
    Recycle,
    HeartHandshake,
    School,
    Music,
    GraduationCap,
    Presentation,
    Sparkles,
    Building2,
    Copy,
    Phone,
    Mail,
} from "lucide-react";
import { toast } from "sonner";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import OrnamentalDivider from "../components/site/OrnamentalDivider";
import { ASSETS, GURUKULA } from "../lib/api";

const INITIATIVES = [
    {
        Icon: Recycle,
        titleKn: "ಪೌರಕಾರ್ಮಿಕರಲ್ಲೊಬ್ಬ ಕಲಾವಿದ",
        titleEn: "Artists Among Cleanliness Warriors",
        descKn:
            "ನಮ್ಮ ನಗರವನ್ನು ಸ್ವಚ್ಛವಾಗಿಡುವ ಪೌರಕಾರ್ಮಿಕರ ಜೀವನದಲ್ಲಿ ಸಾಂಸ್ಕೃತಿಕ ಬೆಳಕು ಚೆಲ್ಲುವ ದಿಟ್ಟ ಪ್ರಯತ್ನ. ರಾಜ್ಯಾದ್ಯಂತ ಇರುವ ಪೌರಕಾರ್ಮಿಕರನ್ನು ಸಂಘಟಿಸಿ, ಅವರಲ್ಲಿ ಅಡಗಿರುವ ಸುಪ್ತ ಪ್ರತಿಭೆಯನ್ನು ಹೊರತಂದು ಸಮಾಜದ ಮುಖ್ಯವಾಹಿನಿಗೆ ಕೊಂಡೊಯ್ಯುವುದು ಈ ಯೋಜನೆಯ ಮುಖ್ಯ ಉದ್ದೇಶ.",
        descEn:
            "A bold movement to bring cultural light into the lives of the sanitation workers who keep our city clean — discovering the hidden artists within them and bringing their talent into the mainstream of society.",
        serviceKn:
            "ಪೌರಕಾರ್ಮಿಕರಿಗೆ ಹಾಗೂ ಅವರ ಮಕ್ಕಳಿಗೆ ಉಚಿತವಾಗಿ ಸಂಸ್ಕಾರಯುತ ಸಂಗೀತ ಶಿಕ್ಷಣ.",
        serviceEn:
            "Free, value-rooted music education for pourakarmikas and their children.",
        callKn:
            "ಈ ಮಹತ್ಕಾರ್ಯದಲ್ಲಿ ಸ್ವಯಂಪ್ರೇರಿತರಾಗಿ ಸೇವೆ ಸಲ್ಲಿಸಲು ಬಯಸುವ ಸಂಗೀತ ಶಿಕ್ಷಕರು ಮತ್ತು ಕಲಾವಿದರನ್ನು ಮುಕ್ತವಾಗಿ ಸ್ವಾಗತಿಸುತ್ತೇವೆ.",
        callEn:
            "We warmly welcome music teachers and artists who wish to volunteer their service in this great cause.",
    },
    {
        Icon: HeartHandshake,
        titleKn: "ಅನಾಥಾಶ್ರಮದ ಮಕ್ಕಳಿಗೆ ಉಚಿತ ಸಂಗೀತ ಮತ್ತು ವಾದ್ಯಗಳ ಕೊಡುಗೆ",
        titleEn: "Empowering Orphanages",
        descKn:
            "ಪೋಷಕರಿಲ್ಲದ, ಪ್ರೀತಿಯಿಂದ ವಂಚಿತರಾದ ಅನಾಥಾಶ್ರಮದ ಮಕ್ಕಳಿಗೆ ಹಾಗೂ ಅಂಧ ಕಲಾವಿದರಿಗೆ ಸಂಗೀತವೇ ಆಸರೆ. ವೃದ್ಧಾಶ್ರಮಗಳಲ್ಲಿ ಸಂಗೀತ-ಭಜನಾ ಕಾರ್ಯಕ್ರಮಗಳ ಮೂಲಕ ಮಾನಸಿಕ ಶಾಂತಿ ಮತ್ತು ಆತ್ಮವಿಶ್ವಾಸವನ್ನು ತುಂಬುತ್ತೇವೆ.",
        descEn:
            "For children robbed of parental love, for visually-impaired artists, and for the elders in old-age homes — music becomes solace. Through bhajan gatherings and free training, we restore peace and self-belief.",
        serviceKn:
            "ಉಚಿತ ಸಂಗೀತ ತರಬೇತಿಯ ಜೊತೆಗೆ, ಮಕ್ಕಳಿಗೆ ಅಗತ್ಯವಿರುವ ಸಂಗೀತ ವಾದ್ಯಗಳನ್ನು ಗುರುಕುಲದ ವತಿಯಿಂದ ಉಚಿತವಾಗಿ ಒದಗಿಸಲಾಗುತ್ತಿದೆ.",
        serviceEn:
            "Beyond free training, the Gurukula gifts musical instruments to the children who need them — without cost, without condition.",
    },
    {
        Icon: School,
        titleKn: "ಸರ್ಕಾರಿ ಶಾಲೆಗಳಲ್ಲಿ ಸಂಗೀತ ಸಂಸ್ಕಾರ",
        titleEn: "Cultural Awareness in Government Schools",
        descKn:
            "ಬಡ ಮತ್ತು ಮಧ್ಯಮ ವರ್ಗದ ಮಕ್ಕಳು ಕಲಿಯುವ ಸರ್ಕಾರಿ ಶಾಲೆಗಳಲ್ಲಿ ಕಲೆ ಮತ್ತು ಸಂಸ್ಕೃತಿಯ ಅರಿವು ಮೂಡಿಸುವುದು ನಮ್ಮ ಜವಾಬ್ದಾರಿ.",
        descEn:
            "Awakening cultural and artistic consciousness in government schools — where children from underprivileged and middle-class families learn — is a responsibility we hold with pride.",
        serviceKn:
            "ವಿಶೇಷ ಕಾರ್ಯಾಗಾರಗಳು, ವಿಚಾರ ಸಂಕಿರಣಗಳು ಮತ್ತು ಸಂಗೀತ ಸಂಸ್ಕಾರ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ನಿರಂತರವಾಗಿ ಆಯೋಜಿಸಲಾಗುತ್ತಿದೆ.",
        serviceEn:
            "We continuously host special workshops, seminars and music-sanskara programmes — teaching children not just syllabus, but the values that shape a life.",
    },
];

const SUPPORT_WAYS = [
    {
        Icon: Music,
        titleKn: "ವಾದ್ಯಗಳ ಕೊಡುಗೆ",
        titleEn: "Sponsor an Instrument",
        body:
            "Sponsor a harmonium, tabla or tanpura for an orphanage child — and gift them a lifelong companion in music.",
    },
    {
        Icon: GraduationCap,
        titleKn: "ಶಿಕ್ಷಣ ಪ್ರಾಯೋಜಕತ್ವ",
        titleEn: "Sponsor a Student",
        body:
            "Cover the full music + academic education of a pourakarmika's child or an economically backward student.",
    },
    {
        Icon: Presentation,
        titleKn: "ಕಾರ್ಯಾಗಾರಗಳ ಪ್ರಾಯೋಜಕತ್ವ",
        titleEn: "Sponsor a Workshop",
        body:
            "Fund a free sanskara workshop or seminar at a government school — and seed culture into hundreds of young minds.",
    },
    {
        Icon: Sparkles,
        titleKn: "ಸ್ವಯಂಪ್ರೇರಿತ ದೇಣಿಗೆ",
        titleEn: "General Donation",
        body:
            "Give any amount — large or small — toward the overall running of our social-service initiatives.",
    },
];

export default function SocialService() {
    return (
        <div data-testid="social-page" className="bg-ivory text-ink">
            <Navbar />

            {/* HERO */}
            <section className="relative bg-cream overflow-hidden" data-testid="social-hero">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10 lg:pt-24 lg:pb-14 text-center">
                    <div className="eyebrow">· ಸಮಾಜ ಸೇವೆ · Social Service ·</div>
                    <h1 className="text-kannada font-semibold text-3xl sm:text-5xl lg:text-6xl text-maroon mt-6 leading-tight">
                        ಸಂಗೀತದ ಮೂಲಕ ಸಂಸ್ಕಾರ ಮತ್ತು ಪರಿವರ್ತನೆ
                    </h1>
                    <p className="font-display italic text-2xl lg:text-4xl text-gold mt-4">
                        Sanskara and transformation, through music.
                    </p>
                    <p className="font-serif text-lg lg:text-xl text-ink/85 mt-6 max-w-3xl mx-auto leading-relaxed">
                        Shri Vishwa Bandhu Sangeetha Gurukula is not merely an institution. It is
                        a sacred platform striving — through music — to bring positive change in
                        society. Under the vision and leadership of <strong>Shri Ananya Bhargava
                        Bedur</strong>, our service is to carry art and music to every doorstep,
                        every life.
                    </p>
                </div>

                <div className="max-w-6xl mx-auto px-6 lg:px-10 pb-20">
                    <div className="relative">
                        <div className="absolute -inset-3 border border-gold/40 pointer-events-none" />
                        <div className="absolute -inset-1 border border-gold/20 pointer-events-none" />
                        <img
                            src={ASSETS.socialPourakarmika}
                            alt="Shri Ananya Bhargava teaches music to BBMP pourakarmikas (sanitation workers) — Artists Among Cleanliness Warriors initiative"
                            data-testid="social-hero-image"
                            className="relative w-full h-auto object-cover shadow-[0_40px_80px_-30px_rgba(90,17,31,0.5)]"
                        />
                        <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 bg-gradient-to-t from-maroon-900/95 via-maroon-900/40 to-transparent text-ivory">
                            <div className="eyebrow text-gold-300">· Initiative in Motion ·</div>
                            <div className="font-display italic text-xl lg:text-2xl mt-1">
                                "Artists Among Cleanliness Warriors" — a session with BBMP
                                pourakarmikas.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* INITIATIVES */}
            <section className="section-pad bg-ivory" data-testid="social-initiatives">
                <div className="max-w-7xl mx-auto px-6 lg:px-10">
                    <div className="text-center mb-16">
                        <div className="eyebrow">· ಪ್ರಮುಖ ಯೋಜನೆಗಳು · Our Key Initiatives ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-maroon mt-4 leading-tight">
                            Three streams of
                            <span className="italic text-gold"> service.</span>
                        </h2>
                        <OrnamentalDivider className="mt-6" />
                    </div>

                    <div className="space-y-12">
                        {INITIATIVES.map((it, i) => {
                            const Icon = it.Icon;
                            const isOdd = i % 2 === 1;
                            return (
                                <div
                                    key={it.titleEn}
                                    data-testid={`social-initiative-${i}`}
                                    className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch"
                                >
                                    <div
                                        className={`lg:col-span-5 bg-maroon text-ivory p-8 lg:p-10 relative overflow-hidden ${
                                            isOdd ? "lg:order-2" : ""
                                        }`}
                                    >
                                        <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
                                        <div className="relative flex items-center justify-between mb-6">
                                            <div className="w-14 h-14 flex items-center justify-center bg-ivory text-maroon">
                                                <Icon size={22} />
                                            </div>
                                            <span className="font-display italic text-gold-300 text-5xl">
                                                {String(i + 1).padStart(2, "0")}
                                            </span>
                                        </div>
                                        <div className="eyebrow text-gold-300">
                                            · ಯೋಜನೆ · Initiative {String(i + 1).padStart(2, "0")} ·
                                        </div>
                                        <h3 className="text-kannada text-2xl text-ivory mt-3 font-semibold leading-tight">
                                            {it.titleKn}
                                        </h3>
                                        <p className="font-display italic text-2xl lg:text-3xl text-gold-300 mt-2 leading-snug">
                                            {it.titleEn}
                                        </p>
                                    </div>

                                    <div
                                        className={`lg:col-span-7 card-cream p-8 lg:p-10 ${
                                            isOdd ? "lg:order-1" : ""
                                        }`}
                                    >
                                        <div className="eyebrow text-gold">· ವಿವರಣೆ · Description ·</div>
                                        <p className="text-kannada text-lg text-ink/90 mt-3 leading-relaxed">
                                            {it.descKn}
                                        </p>
                                        <p className="font-serif italic text-lg lg:text-xl text-ink/85 mt-3 leading-relaxed">
                                            {it.descEn}
                                        </p>

                                        <div className="mt-6 pt-6 border-t border-gold-100">
                                            <div className="eyebrow text-gold">· ಸೇವೆ · The Service ·</div>
                                            <p className="text-kannada text-base text-maroon mt-3 leading-relaxed">
                                                {it.serviceKn}
                                            </p>
                                            <p className="font-display italic text-lg text-maroon/85 mt-2 leading-snug">
                                                {it.serviceEn}
                                            </p>
                                        </div>

                                        {it.callKn && (
                                            <div className="mt-5 bg-cream border-l-2 border-gold p-4">
                                                <div className="eyebrow text-gold">· Call to Action ·</div>
                                                <p className="text-kannada text-base text-ink/85 mt-2 leading-relaxed">
                                                    {it.callKn}
                                                </p>
                                                <p className="font-serif italic text-base lg:text-lg text-ink/80 mt-2 leading-relaxed">
                                                    {it.callEn}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* FOUNDER'S LETTER */}
            <section className="section-pad bg-cream" data-testid="social-letter">
                <div className="max-w-5xl mx-auto px-6 lg:px-10">
                    <div className="text-center">
                        <div className="eyebrow">· ದಯವಿಟ್ಟು ನೀವೂ ಕೈಜೋಡಿಸಿ · Please Join Hands ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl text-maroon mt-4 leading-tight">
                            Be part of a quiet
                            <span className="italic text-gold"> revolution.</span>
                        </h2>
                    </div>

                    <div className="mt-12 bg-ivory border border-gold-100 p-8 lg:p-12">
                        <p className="text-kannada text-lg text-ink/90 leading-relaxed">
                            ಪ್ರೀತಿಯ ಕಲಾಭಿಮಾನಿ ಹಾಗೂ ಸಹೃದಯಿ ಬಂಧುಗಳೇ,
                        </p>

                        <div className="my-6 border-l-4 border-gold pl-6">
                            <p className="text-kannada text-xl lg:text-2xl text-maroon font-semibold leading-snug">
                                “ಯಾವ ಕಲೆ ಸಮಾಜದ ಕೊನೆಯ ವ್ಯಕ್ತಿಯ ಮುಖದಲ್ಲಿ ನಗು ತರಿಸುತ್ತದೆಯೋ, ಅದೇ ನಿಜವಾದ ಕಲೆ.”
                            </p>
                            <p className="font-display italic text-lg lg:text-xl text-gold mt-3 leading-snug">
                                “Only that art is true art which can bring a smile on the face of
                                the very last person in society.”
                            </p>
                        </div>

                        <p className="text-kannada text-base text-ink/85 leading-relaxed mt-6">
                            ಶ್ರೀ ವಿಶ್ವ ಬಂಧು ಸಂಗೀತ ಗುರುಕುಲವು ಕೇವಲ ರಾಗ-ತಾಳಗಳನ್ನು ಕಲಿಸುವ ಶಾಲೆಯಲ್ಲ;
                            ಇದು ಸಂಗೀತದ ಮಾಧ್ಯಮದ ಮೂಲಕ ಸಮಾಜದ ಕಟ್ಟಕಡೆಯ ವ್ಯಕ್ತಿಗೂ "ಸಂಸ್ಕಾರ, ನೆಮ್ಮದಿ
                            ಮತ್ತು ನವ ಚೈತನ್ಯ" ನೀಡುವ ಮಹತ್ಕಾರ್ಯದಲ್ಲಿ ತೊಡಗಿಸಿಕೊಂಡಿದೆ.
                        </p>
                        <p className="font-serif italic text-xl lg:text-2xl text-ink/85 leading-relaxed mt-4">
                            The Gurukula is not merely a school that teaches ragas and talas — it
                            is a movement that carries <em>sanskara, peace and renewed
                            consciousness</em> to even the last person in society, through the
                            medium of music.
                        </p>

                        <p className="text-kannada text-base text-ink/85 leading-relaxed mt-6">
                            ನಮ್ಮ ನಗರವನ್ನು ಸ್ವಚ್ಛವಾಗಿಡುವ ಪೌರಕಾರ್ಮಿಕರಲ್ಲಿ ಅಡಗಿರುವ ಕಲಾವಿದನನ್ನು
                            ಗುರುತಿಸಿ ಗೌರವ ತಂದುಕೊಡುವುದು, ಅನಾಥಾಶ್ರಮದ ಮಕ್ಕಳಿಗೆ ಉಚಿತ ವಾದ್ಯಗಳನ್ನು
                            ನೀಡಿ ಸಂಗೀತದ ಬೆಳಕು ಚೆಲ್ಲುವುದು, ಸರ್ಕಾರಿ ಶಾಲೆಯ ಅವಕಾಶ ವಂಚಿತ ಮಕ್ಕಳಿಗೆ
                            ಉಚಿತ ಸಂಗೀತ ಸಂಸ್ಕಾರ ಶಿಬಿರಗಳನ್ನು ನಡೆಸುವುದು — ಇವು ನಮ್ಮ ಹೆಮ್ಮೆಯ ಯೋಜನೆಗಳು.
                        </p>
                        <p className="font-serif italic text-xl lg:text-2xl text-ink/85 leading-relaxed mt-4">
                            Recognising the hidden artist in the pourakarmika who keeps our streets
                            clean; placing free instruments in the hands of orphaned children;
                            running free music-sanskara workshops for the children of government
                            schools — these are the projects we hold close to our hearts.
                        </p>

                        <div className="mt-8 p-6 bg-maroon text-ivory border border-gold/40">
                            <p className="text-kannada text-base text-ivory/95 leading-relaxed">
                                ಈ ಎಲ್ಲಾ ಸೇವೆಗಳನ್ನು ನಾವು ಸಂಪೂರ್ಣವಾಗಿ ಉಚಿತವಾಗಿ ನಡೆಸುತ್ತಿದ್ದೇವೆ.
                                ಈ ಆಂದೋಲನ ನಿರಂತರವಾಗಿ ಸಾಗಲು ಮತ್ತು ಹೆಚ್ಚಿನ ಜನರನ್ನು ತಲುಪಲು ನಿಮ್ಮಂತಹ
                                ಸಹೃದಯಿ ದಾನಿಗಳ ಮತ್ತು ಕಲಾಭಿಮಾನಿಗಳ ನೆರವು ಬೇಕಾಗಿದೆ.
                            </p>
                            <p className="font-display italic text-lg text-gold-300 mt-3 leading-snug">
                                Every one of these services is run completely free of cost. For
                                this movement to continue and to reach more lives, we need the
                                support of hearts like yours.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* HOW YOU CAN SUPPORT */}
            <section className="section-pad bg-ivory" data-testid="social-support">
                <div className="max-w-7xl mx-auto px-6 lg:px-10">
                    <div className="text-center mb-14">
                        <div className="eyebrow">· ನೀವು ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು · How You Can Support ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-maroon mt-4 leading-tight">
                            One contribution. One
                            <span className="italic text-gold"> instrument in a child's hands.</span>
                        </h2>
                        <p className="font-serif text-lg text-ink/80 max-w-3xl mx-auto mt-5 leading-relaxed">
                            Every small gift you make can place an instrument in the hands of a
                            child — or place a pourakarmika artist on a real stage, for the very
                            first time.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {SUPPORT_WAYS.map((w, i) => {
                            const Icon = w.Icon;
                            return (
                                <div
                                    key={w.titleEn}
                                    data-testid={`support-way-${i}`}
                                    className="card-cream p-7 flex flex-col"
                                >
                                    <div className="flex items-center justify-between mb-5">
                                        <div className="w-12 h-12 flex items-center justify-center bg-maroon text-gold-300">
                                            <Icon size={20} />
                                        </div>
                                        <span className="font-display italic text-gold text-3xl">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                    </div>
                                    <h3 className="text-kannada text-xl text-maroon font-semibold leading-tight">
                                        {w.titleKn}
                                    </h3>
                                    <p className="font-display italic text-xl text-gold mt-1 leading-snug">
                                        {w.titleEn}
                                    </p>
                                    <p className="font-serif text-lg text-ink/85 leading-relaxed mt-4 flex-1">
                                        {w.body}
                                    </p>
                                </div>
                            );
                        })}
                    </div>

                    <div className="mt-12 bg-maroon text-ivory p-8 lg:p-10 border border-gold/40 text-center" data-testid="social-appeal">
                        <div className="eyebrow text-gold-300">📢 · ನಮ್ಮ ವಿನಂತಿ · Our Appeal ·</div>
                        <p className="text-kannada text-xl lg:text-2xl text-ivory mt-5 leading-snug font-semibold">
                            “ನೀವು ನೀಡುವ ಹಣ ಕೇವಲ ದೇಣಿಗೆಯಲ್ಲ — ಇದು ಸಮಾಜದ ಸ್ವಾಸ್ಥ್ಯವನ್ನು ಕಾಯುವ
                            ಮತ್ತು ಕಲೆಯ ಮೂಲಕ ಮೌಲ್ಯಗಳನ್ನು ಬಿತ್ತುವ ಒಂದು ಮಹಾನ್ ಕಾರ್ಯಕ್ಕೆ ನೀಡುವ ಉಡುಗೊರೆ.”
                        </p>
                        <p className="font-display italic text-xl lg:text-2xl text-gold-300 mt-4 leading-snug">
                            “What you give is not a donation. It is a gift to a movement that
                            protects the soul of society and sows values through art.”
                        </p>
                    </div>
                </div>
            </section>

            {/* BANK DETAILS + CONTACT */}
            <section className="section-pad bg-maroon-900 text-ivory" data-testid="social-bank">
                <div className="max-w-6xl mx-auto px-6 lg:px-10">
                    <div className="text-center mb-12">
                        <div className="eyebrow text-gold-300">· 💳 · ಬ್ಯಾಂಕ್ ಖಾತೆಯ ವಿವರಗಳು · Bank Details ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl text-ivory mt-4 leading-tight">
                            Give directly to the
                            <span className="italic text-gold-300"> Trust account.</span>
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                        <div className="lg:col-span-7 bg-ivory text-ink p-8 lg:p-10 border border-gold/40">
                            <div className="flex items-center gap-3 mb-6">
                                <div className="w-12 h-12 flex items-center justify-center bg-maroon text-gold-300">
                                    <Building2 size={20} />
                                </div>
                                <div className="font-display text-2xl text-maroon leading-tight">
                                    Canara Bank
                                    <span className="block font-serif italic text-base text-ink/70">
                                        Chandra Layout, Bangalore – 560040
                                    </span>
                                </div>
                            </div>

                            <dl className="divide-y divide-gold-100">
                                {[
                                    { k: "Account Name", v: "Shri Vishwa Bandhu Sangeetha Gurukula", mono: false },
                                    { k: "Bank Name", v: GURUKULA.bank.bankName, mono: false },
                                    { k: "Account Number", v: GURUKULA.bank.account, mono: true },
                                    { k: "IFSC Code", v: GURUKULA.bank.ifsc, mono: true },
                                    { k: "Branch", v: GURUKULA.bank.branch, mono: false },
                                    { k: "UPI (GPay / PhonePe)", v: GURUKULA.upiNumber, mono: true },
                                ].map((row) => (
                                    <div
                                        key={row.k}
                                        className="py-3 grid grid-cols-12 gap-3 items-center"
                                    >
                                        <dt className="col-span-12 sm:col-span-5 eyebrow text-ink/60">
                                            {row.k}
                                        </dt>
                                        <dd
                                            className={
                                                "col-span-12 sm:col-span-7 text-maroon " +
                                                (row.mono
                                                    ? "font-sans font-medium text-lg tabular-nums tracking-[0.06em]"
                                                    : "font-display text-lg")
                                            }
                                        >
                                            {row.v}
                                            {row.mono && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        navigator.clipboard?.writeText(row.v);
                                                        toast.success(`${row.k} copied.`);
                                                    }}
                                                    className="ml-3 align-middle text-gold hover:text-maroon transition-colors"
                                                    aria-label={`Copy ${row.k}`}
                                                >
                                                    <Copy size={14} />
                                                </button>
                                            )}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        </div>

                        <div className="lg:col-span-5 space-y-5">
                            <a
                                href={`tel:${GURUKULA.phone}`}
                                data-testid="social-phone"
                                className="block bg-maroon border border-gold/30 p-7 hover:border-gold-300 transition-colors"
                            >
                                <div className="eyebrow text-gold-300 flex items-center gap-2">
                                    <Phone size={12} /> ಸಂಪರ್ಕಿಸಿ · Contact
                                </div>
                                <div className="font-sans font-medium text-3xl lg:text-4xl tabular-nums tracking-[0.08em] text-ivory mt-3">
                                    {GURUKULA.phone}
                                </div>
                                <div className="font-serif italic text-base lg:text-lg text-ivory/85 mt-3">
                                    Call or WhatsApp for any support or partnership inquiry.
                                </div>
                            </a>

                            <a
                                href={`mailto:${GURUKULA.donationEmail}`}
                                data-testid="social-email"
                                className="block bg-maroon border border-gold/30 p-7 hover:border-gold-300 transition-colors"
                            >
                                <div className="eyebrow text-gold-300 flex items-center gap-2">
                                    <Mail size={12} /> ಇಮೇಲ್ · Email
                                </div>
                                <div className="font-display text-xl text-ivory mt-3 break-all">
                                    {GURUKULA.donationEmail}
                                </div>
                            </a>

                            <Link
                                to="/vision#donate"
                                data-testid="social-go-donate"
                                className="block w-full text-center bg-gold text-maroon font-sans text-[12px] tracking-[0.28em] uppercase px-6 py-4 hover:bg-gold-300 transition-colors"
                            >
                                See full Donate page →
                            </Link>
                        </div>
                    </div>

                    <p className="text-center text-kannada text-lg text-gold-300 mt-12 max-w-3xl mx-auto leading-relaxed">
                        ನಿಮ್ಮ ಕೈಲಾದ ಸಹಾಯವನ್ನು ನೇರವಾಗಿ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ವರ್ಗಾಯಿಸಿ ಅಥವಾ ಕಚೇರಿಗೆ
                        ಭೇಟಿ ನೀಡಿ ವಾದ್ಯಗಳ ರೂಪದಲ್ಲಿ ನೀಡಿ — ಈ ಸಾಂಸ್ಕೃತಿಕ ಕ್ರಾಂತಿಯಲ್ಲಿ ಭಾಗಿಯಾಗಿ.
                    </p>
                    <p className="text-center font-display italic text-lg text-ivory/80 mt-3 max-w-3xl mx-auto leading-relaxed">
                        Transfer your contribution directly to the bank account, or visit our
                        office to donate musical instruments — and step into this cultural
                        revolution with us.
                    </p>
                </div>
            </section>

            <Footer />
        </div>
    );
}
